import React from "react";
import { toast } from 'react-toastify';
import { UtilityFunctions } from "../../src/utils/UtilityFunctions";

const ValidationErrorToast = (errHeader: any, errBody: any) => {

  return (
    toast(<div>
      <span className="toast-header">{errHeader}</span>
      <br />
      {errBody}
    </div>, {
      icon: ({ theme, type }) => <img alt="" className="toast-icon" src={UtilityFunctions.getImageURL() + "error-toast-icon.svg"} />
    })

  )
}
export default ValidationErrorToast;